import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { openChat } from "../../lib/api";

const links = [
  ["#amour", "Amour"],
  ["#travail", "Travail"],
  ["#voyance", "Voyance"],
  ["#football", "Football"],
  ["#confiance", "Confiance"],
  ["#rituels", "Rituels"],
];

const go = (e, href) => {
  e.preventDefault();
  if (window.__lenis) window.__lenis.scrollTo(href, { offset: -80 });
  else document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
};

export const Nav = () => (
  <motion.header
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
    className="fixed inset-x-0 top-0 z-50 border-b border-amber-900/30 bg-[#0a0908]/70 backdrop-blur-xl"
    data-testid="site-nav"
  >
    <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 md:px-10">
      <a href="#top" onClick={(e) => go(e, "#top")} className="flex items-center gap-3" data-testid="nav-logo">
        <Logo size={36} />
        <span className="font-display text-sm tracking-wider text-amber-100 md:text-base">Maître Wouffa</span>
      </a>
      <nav className="hidden items-center gap-8 md:flex">
        {links.map(([h, l]) => (
          <a key={h} href={h} onClick={(e) => go(e, h)} data-testid={`nav-link-${l.toLowerCase()}`}
            className="font-mono-x text-xs uppercase tracking-[0.2em] text-stone-300 transition-colors hover:text-amber-300">
            {l}
          </a>
        ))}
      </nav>
      <button onClick={() => openChat()} data-testid="nav-chat-button"
        className="group flex items-center gap-2 rounded-full border border-amber-500/50 px-4 py-2 text-xs font-semibold uppercase tracking-[0.15em] text-amber-200 transition-colors duration-300 hover:bg-amber-400 hover:text-stone-950">
        <MessageCircle className="h-4 w-4" />
        <span>Consulter</span>
      </button>
    </div>
  </motion.header>
);
